import React from 'react';
import { Sparkles } from 'lucide-react';

const AiLearningPrompt = ({
  subQuestionId,
  isVisible,
  isLoading,
  onTriggerLearning,
  onDismiss
}) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div className="ai-learning-modal mb-3">
      <div className="ai-learning-header">
        <div className="flex items-center gap-3">
          <div className="ai-learning-icon">
            <Sparkles className="w-4 h-4" />
          </div>
          <h4 className="ai-learning-title">
            AI Learning Available
          </h4>
        </div>
      </div>
      <div className="ai-learning-content">
        <p className="ai-learning-description">
          GradeWiz AI now has enough feedback to learn from your corrections. The AI will learn from both thumbs up and thumbs down ratings, plus your written feedback to improve its grading accuracy.
        </p>
        <div className="ai-learning-actions">
          <button
            onClick={() => onTriggerLearning(subQuestionId)}
            disabled={isLoading}
            className="ai-learning-button primary"
          >
            {isLoading ? (
              <>
                <div className="spinner" style={{
                  width: '16px',
                  height: '16px',
                  border: '2px solid rgba(255, 255, 255, 0.3)',
                  borderRadius: '50%',
                  borderTopColor: '#fff'
                }}></div>
                Processing...
              </>
            ) : (
              <>
                <Sparkles className="w-4 h-4" />
                Yes, Learn & Regrade
              </>
            )}
          </button>
          <button
            onClick={onDismiss}
            className="ai-learning-button secondary"
          >
            Not Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default AiLearningPrompt;